import { ForgotPasswordForm } from "wasp/client/auth";
import { AuthPageLayout } from "../AuthPageLayout";

const authAppearance = {
  colors: {
    brand: "#EC4899", // primary pink-500
    brandAccent: "#F9A8D4", // secondary pink-300
    submitButtonText: "white",
    inputBackground: "white",
    inputBorder: "#F5D0FE", // stroke color
    inputBorderHover: "#F9A8D4", // secondary color
    inputBorderFocus: "#EC4899", // primary color
    dividerBackground: "#F5D0FE", // stroke color
  },
  borderRadii: {
    inputBorderRadius: "6px",
    buttonBorderRadius: "6px",
  },
};

export function RequestPasswordResetPage() {
  return (
    <AuthPageLayout>
      <ForgotPasswordForm appearance={authAppearance} />
    </AuthPageLayout>
  );
}
